function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import deprecated from 'deprecated-prop-type';
import React from 'react';
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import addWeeks from 'date-fns/add_weeks';
import addYears from 'date-fns/add_years';
import Fecha from 'fecha'; // TODO replace with date-fns/parse after v2 is released

import format from 'date-fns/format';
import isSameDay from 'date-fns/is_same_day';
import isValid from 'date-fns/is_valid';
import startOfToday from 'date-fns/start_of_today';
import enLocale from 'date-fns/locale/en';
import Button from "./Button";
import ButtonGroup from "./ButtonGroup";
import Calendar from "./Calendar";
import Dropdown from "./Dropdown";
import DropdownMenu from "./DropdownMenu";
import Icon from "./Icon";
import InputGroup from "./InputGroup";
import InputGroupAddon from "./InputGroupAddon";
import DropdownToggle from "./DropdownToggle";
var _parse = Fecha.parse;
/**
 * Given a defaultValue, return the corresponding calendar date and input string value:
 *
 * | defaultValue   | date  | string         |
 * |----------------|-------|----------------|
 * | null,          | today | ''             |
 * | Date           | Date  | 'M/D/YYYY'     |
 * | 'M/D/YYYY'     | Date  | 'M/D/YYYY'     |
 * | invalid string | today | invalid string |
 */

function parseValue(defaultValue, dateFormat, parseDate) {
  var date;

  if (defaultValue) {
    if (defaultValue instanceof Date) {
      date = defaultValue;
    } else {
      date = parseDate(defaultValue, dateFormat);

      try {
        if (!isValid(date)) {
          date = new Date();
        }
      } catch (e) {
        date = new Date();
      }
    }
  } else {
    date = new Date();
  }

  return date;
}

var DateInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DateInput, _React$Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);

    _this.onChange = function (value) {
      _this.setState({
        value: value
      });

      _this.parseInput(value);
    };

    _this.onSelect = function (newDate) {
      return _this.setDate(newDate, true);
    };

    _this.onKeyDown = function (event) {
      // Ignore arrows if closed, disabled, or modifiers are down:
      var allowArrows = _this.state.open && _this.props.keyboard && !(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);

      switch (event.keyCode) {
        case 9:
          // TAB
          _this.setState({
            open: false
          });

          break;

        case 13:
          // Enter
          if (_this.state.open) {
            // To avoid submitting the form if DateInput is contained in a form
            event.preventDefault();

            _this.setState({
              open: false
            });
          }

          break;

        case 27:
          // Esc
          if (_this.state.open) {
            // To avoid parent elements handling the ESC key (like modals closing)
            event.stopPropagation();

            _this.setState({
              open: false
            });
          }

          break;

        case 37:
          // Left
          if (allowArrows) _this.setDate(addDays(_this.getCurrentDate(), -1));
          break;

        case 38:
          // Up
          if (allowArrows) _this.setDate(addWeeks(_this.getCurrentDate(), -1));
          break;

        case 39:
          // Right
          if (allowArrows) _this.setDate(addDays(_this.getCurrentDate(), 1));
          break;

        case 40:
          // Down
          if (allowArrows) _this.setDate(addWeeks(_this.getCurrentDate(), 1));
          break;

        default:
      }

      return true;
    };

    _this.setDate = function (date) {
      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var newState = close ? {
        value: format(date, _this.props.dateFormat, {
          locale: _this.props.locale
        }),
        open: false
      } : {
        value: format(date, _this.props.dateFormat, {
          locale: _this.props.locale
        })
      };

      _this.setState(newState, function () {
        _this.inputEl.setAttribute('value', newState.value);

        _this.props.onChange(date, true);
      });
    };

    _this.getCurrentValue = function () {
      if (_this.props.value !== undefined) {
        if (_this.props.value instanceof Date) {
          return format(_this.props.value, _this.props.dateFormat, {
            locale: _this.props.locale
          });
        }

        return _this.props.value;
      }

      return _this.state.value;
    };

    _this.getCurrentDate = function () {
      return parseValue(_this.props.value !== undefined ? _this.props.value : _this.state.value, _this.props.dateFormat, _this.props.parse);
    };

    _this.parseInput = function (value) {
      var date = _this.props.parse(value, _this.props.dateFormat);

      if (date) {
        _this.props.onChange(date, true);
      } else {
        _this.props.onChange(value, false);
      }

      _this.inputEl.setAttribute('value', value);
    };

    _this.clear = function () {
      return _this.onChange('');
    };

    _this.close = function () {
      return _this.setState({
        open: false
      });
    };

    _this.nextMonth = function () {
      return _this.setDate(addMonths(_this.getCurrentDate(), 1));
    };

    _this.nextYear = function () {
      return _this.setDate(addYears(_this.getCurrentDate(), 1));
    };

    _this.prevMonth = function () {
      return _this.setDate(addMonths(_this.getCurrentDate(), -1));
    };

    _this.prevYear = function () {
      return _this.setDate(addYears(_this.getCurrentDate(), -1));
    };

    _this.show = function () {
      return _this.setState({
        open: true
      });
    };

    _this.today = function () {
      return _this.setDate(startOfToday(), true);
    };

    _this.toggle = function () {
      return _this.state.open ? _this.close() : _this.show();
    };

    _this.setInputValue = function () {
      if (!_this.inputEl) {
        return;
      }

      var currentValue = _this.getCurrentValue();

      var inputValue = _this.inputEl.value;

      var currentValueAsDate = currentValue && _this.props.parse(currentValue, _this.props.dateFormat);

      var inputValueAsDate = _this.props.parse(inputValue || '', _this.props.dateFormat);

      var isSame = currentValueAsDate && inputValueAsDate && isSameDay(currentValueAsDate, inputValueAsDate) || inputValue === currentValue;

      if (!isSame) {
        _this.inputEl.value = currentValue;

        _this.inputEl.setAttribute('value', currentValue);
      }
    };

    _this.onBlur = function (e) {
      _this.props.onBlur(e);

      var parsedDate = _this.props.parse(_this.inputEl.value, _this.props.dateFormat);

      if (parsedDate) {
        var value = format(parsedDate, _this.props.dateFormat, {
          locale: _this.props.locale
        });
        _this.inputEl.value = value;

        _this.inputEl.setAttribute('value', value);
      }
    };

    var _value = props.defaultValue || '';

    if (props.defaultValue instanceof Date) {
      _value = format(_value, props.dateFormat, {
        locale: props.locale
      });
    }

    _this.state = {
      open: false,
      value: _value
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: "focus",
    value: function focus() {
      this.inputEl.focus();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setInputValue();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.setInputValue();

      if (this.props.onClose && this.state.open !== prevState.open && !this.state.open) {
        var value = this.props.value !== undefined ? this.props.value : this.state.value;
        var date = this.props.parse(value, this.props.dateFormat);

        if (date) {
          this.props.onClose(date, true);
        } else {
          this.props.onClose(value, false);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          dateEnabled = _this$props.dateEnabled,
          dateVisible = _this$props.dateVisible,
          direction = _this$props.direction,
          disabled = _this$props.disabled,
          footer = _this$props.footer,
          header = _this$props.header,
          renderFooter = _this$props.renderFooter,
          renderHeader = _this$props.renderHeader,
          id = _this$props.id,
          showOnFocus = _this$props.showOnFocus,
          dateFormat = _this$props.dateFormat,
          defaultValue = _this$props.defaultValue,
          keyboard = _this$props.keyboard,
          locale = _this$props.locale,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          parse = _this$props.parse,
          positionFixed = _this$props.positionFixed,
          value = _this$props.value,
          state = _this$props.state,
          props = _objectWithoutProperties(_this$props, ["className", "dateEnabled", "dateVisible", "direction", "disabled", "footer", "header", "renderFooter", "renderHeader", "id", "showOnFocus", "dateFormat", "defaultValue", "keyboard", "locale", "onBlur", "onChange", "parse", "positionFixed", "value", "state"]); // eslint-disable-line no-shadow


      var open = this.state.open;
      var date = this.getCurrentDate();
      var dropdownProps = open ? {
        positionFixed: positionFixed
      } : {}; // <DropdownToggle tag="div" disabled> is to wrap the input in a container for positioning dropdown/up, without breaking showOnFocus
      // TODO extract a DropdownInput component that can encapsulate the defaultValue/value controlled/uncontrolled behavior.

      return (
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(Dropdown, {
          direction: direction,
          isOpen: !disabled && open,
          toggle: this.toggle
        },
        /*#__PURE__*/
        React.createElement(DropdownToggle, {
          tag: "div",
          disabled: true
        },
        /*#__PURE__*/
        React.createElement(InputGroup, {
          className: className
        },
        /*#__PURE__*/
        React.createElement("input", _extends({
          id: id,
          className: "form-control",
          ref: function ref(el) {
            _this2.inputEl = el;
          },
          type: "text",
          onBlur: this.onBlur,
          onChange: function onChange(e) {
            return _this2.onChange(e.target.value);
          },
          onClick: showOnFocus ? this.show : undefined,
          onFocus: showOnFocus ? this.show : undefined,
          onKeyDown: this.onKeyDown,
          disabled: disabled
        }, props)),
        /*#__PURE__*/
        React.createElement(InputGroupAddon, {
          addonType: "append",
          onClick: this.toggle
        },
        /*#__PURE__*/
        React.createElement(Button, {
          className: "px-2",
          disabled: disabled,
          active: open,
          type: "button",
          tabIndex: -1
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "calendar",
          fixedWidth: true
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "sr-only"
        }, "Open Calendar"))))),
        /*#__PURE__*/
        React.createElement(DropdownMenu, _extends({
          className: "p-0",
          onKeyDown: this.onKeyDown
        }, dropdownProps), renderHeader(this.prevMonth, this.nextMonth, this.prevYear, this.nextYear) || header ||
        /*#__PURE__*/
        React.createElement("header", {
          className: "d-flex py-2"
        },
        /*#__PURE__*/
        React.createElement(ButtonGroup, {
          size: "sm"
        },
        /*#__PURE__*/
        React.createElement(Button, {
          className: "js-prev-year",
          color: "link",
          onClick: function onClick() {
            return _this2.prevYear();
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "angle-double-left",
          fixedWidth: true
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "sr-only"
        }, "Previous Year")),
        /*#__PURE__*/
        React.createElement(Button, {
          className: "js-prev-month",
          color: "link",
          onClick: function onClick() {
            return _this2.prevMonth();
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "angle-left",
          fixedWidth: true
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "sr-only"
        }, "Previous Month"))),
        /*#__PURE__*/
        React.createElement("span", {
          className: "js-date-header m-auto"
        }, format(date, 'MMMM YYYY', {
          locale: locale
        })),
        /*#__PURE__*/
        React.createElement(ButtonGroup, {
          size: "sm"
        },
        /*#__PURE__*/
        React.createElement(Button, {
          className: "js-next-month",
          color: "link",
          onClick: function onClick() {
            return _this2.nextMonth();
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "angle-right",
          fixedWidth: true
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "sr-only"
        }, "Next Month")),
        /*#__PURE__*/
        React.createElement(Button, {
          className: "js-next-year",
          color: "link",
          onClick: function onClick() {
            return _this2.nextYear();
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "angle-double-right",
          fixedWidth: true
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "sr-only"
        }, "Next Year")))),
        /*#__PURE__*/
        React.createElement(Calendar, {
          date: date,
          dateEnabled: dateEnabled,
          dateVisible: dateVisible,
          locale: locale,
          onSelect: this.onSelect,
          className: "m-0",
          style: {
            minWidth: '19rem'
          }
        }), renderFooter(this.today, this.clear) || footer ||
        /*#__PURE__*/
        React.createElement("footer", {
          className: "text-center pb-2 pt-1"
        },
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(Button, {
          onClick: this.today,
          className: "mr-2"
        }, "Today"),
        /*#__PURE__*/
        React.createElement(Button, {
          onClick: this.clear,
          className: "mr-2"
        }, "Clear"))))))
      );
    }
  }]);

  return DateInput;
}(React.Component);

DateInput.propTypes = {
  className: PropTypes.string,
  dateEnabled: PropTypes.func,
  dateVisible: PropTypes.func,
  dateFormat: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  direction: PropTypes.string,
  disabled: PropTypes.bool,
  footer: deprecated(PropTypes.node, 'Use renderFooter instead.'),
  header: deprecated(PropTypes.node, 'Use renderHeader insread.'),
  renderFooter: PropTypes.func,
  renderHeader: PropTypes.func,
  id: PropTypes.string,
  keyboard: PropTypes.bool,
  locale: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  parse: PropTypes.func,
  positionFixed: PropTypes.bool,
  showOnFocus: PropTypes.bool,
  state: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
DateInput.defaultProps = {
  className: '',
  dateFormat: 'M/D/YYYY',
  dateEnabled: function dateEnabled() {
    return true;
  },
  dateVisible: function dateVisible() {
    return true;
  },
  disabled: false,
  keyboard: true,
  locale: enLocale,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  parse: function parse(value, dateFormat) {
    return _parse(value, dateFormat);
  },
  renderHeader: function renderHeader() {},
  renderFooter: function renderFooter() {},
  showOnFocus: true
};
DateInput.displayName = "DateInput";
export { DateInput as default };